/* global axios */
import ApiClient from './ApiClient';

class TalkviaSmsAPI extends ApiClient {
  constructor() {
    super('talkvia_sms', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  create(recipients, message, excludedLabels = []) {
    return axios.post(this.url, {
      recipients,
      message,
      excluded_labels: excludedLabels,
    });
  }

  retryFailed(id, recipientId) {
    return axios.post(`${this.url}/${id}/retry_failed`, {
      ...(recipientId ? { recipient_id: recipientId } : {}),
    });
  }

  details(id) {
    return axios.get(`${this.url}/${id}`);
  }

  export(id) {
    return axios.get(`${this.url}/${id}/export`, { responseType: 'blob' });
  }
}

export default new TalkviaSmsAPI();
